"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTableReducer = exports.defaultTableState = void 0;
const ui_components_1 = require("@groupby/ui-components");
const actions_1 = require("./actions");
const table_operations_1 = require("./table-operations");
const actions_2 = require("../../catalogs/actions");
const client_constants_1 = require("../../../client/client.constants");
exports.defaultTableState = {
    dynamicColumns: {
        columnsOrder: [],
        excludedColumns: [],
        filterOptions: [],
        selectAllMode: false,
        reviewAttribute: undefined,
    },
    filter: { items: [], logicOperator: 'and' },
    columnWidth: {},
    search: '',
    sort: null,
    rowSize: ui_components_1.DataGridRowSize.Standard,
    pageSize: client_constants_1.PAGE_SIZE_DEFAULT,
};
// eslint-disable-next-line default-param-last
const createTableReducer = (entityPrefix, defaultState = exports.defaultTableState) => (state = defaultState, action) => {
    switch (action.type) {
        case `${actions_2.CATALOG_PREFIX}${entityPrefix}${actions_1.SET_DYNAMIC_TABLE_COLUMNS_ACTION}`:
            return (0, table_operations_1.applyDynamicTableColumns)(state, action.payload.changes);
        case `${actions_2.CATALOG_PREFIX}${entityPrefix}${actions_1.SET_TABLE_FILTER_ACTION}`:
            return (0, table_operations_1.applyTableFilter)(state, action.payload.changes);
        case `${actions_2.CATALOG_PREFIX}${entityPrefix}${actions_1.SET_TABLE_COLUMN_WIDTH_ACTION}`:
            return (0, table_operations_1.applyTableColumnWidth)(state, action.payload.changes);
        case `${actions_2.CATALOG_PREFIX}${entityPrefix}${actions_1.SET_TABLE_SEARCH_ACTION}`:
            return (0, table_operations_1.applyTableSearch)(state, action.payload.changes);
        case `${actions_2.CATALOG_PREFIX}${entityPrefix}${actions_1.SET_TABLE_SORT_ACTION}`:
            return (0, table_operations_1.applyTableSort)(state, action.payload.changes);
        case `${actions_2.CATALOG_PREFIX}${entityPrefix}${actions_1.SET_ROW_SIZE_ACTION}`:
            return (0, table_operations_1.applyRowSize)(state, action.payload.changes);
        case `${actions_2.CATALOG_PREFIX}${entityPrefix}${actions_1.SET_PAGE_SIZE_ACTION}`:
            return (0, table_operations_1.applyPageSize)(state, action.payload.changes);
        default:
            return state;
    }
};
exports.createTableReducer = createTableReducer;
